<template>
  <div id="dashboard">
    <h1>This is Dashboard</h1>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
    }
  }
}
</script>
